module.exports = __webpack_public_path__ + "img/adopciones4.a35810a6.jpg";